module.exports = __webpack_public_path__ + "img/attach-doc-docx.914d1b34.svg";